import React, { createContext, useContext, useReducer } from "react";
import Reducer from './Reducer';
import axios from 'axios';
import config from '../app.json'

const initialState = {
    isLogged: false,
    loading: false,
    refreshOrdersList: 0,
    profile: null,
    jwt: null,
    ready: false,
    toast: [],
    hubConnection: null
};
export const Context = createContext(initialState);

/* Axios Interceptors */
const WithAxios = ({ children }) => {
    const [state, dispatch] = useContext(Context);

    if (global._interceptor1 != null)
        axios.interceptors.request.eject(global._interceptor1);

    global._interceptor1 = axios.interceptors.request.use(
        request => {
            if (state.jwt != null && request.url.startsWith(config.API_HM)) {
                // request.headers.Authorization = 'Basic ZXRoYW5Ac29jaWFsY2hpbXAuYWk6MTIzNDU2';
                request.headers.Authorization = 'Bearer ' + state.jwt;
                // request?.headers?.common?.Authorization = 'Bearer ' + state.jwt;
                // request.headers.common.Authorization = 'Basic ZXRoYW5Ac29jaWFsY2hpbXAuYWk6MTIzNDU2';
                
            }
            
            dispatch({ type: 'SET_LOADING', payload: true });

            return request;
        }, error => {
            return Promise.reject(error);
        }
    );

    if (global._interceptor2 != null)
        axios.interceptors.response.eject(global._interceptor1);

    global._interceptor2 = axios.interceptors.response.use(
        response => {
            dispatch({ type: 'SET_LOADING', payload: false });
            return response
        },
        error => {
            dispatch({ type: 'SET_LOADING', payload: false });
            var errorParsed = JSON.parse(JSON.stringify(error));

            // Reject promise if usual error
            if (errorParsed.status == "401") {
                if (errorParsed.response == null || errorParsed.response.data == null || (errorParsed.response.data != "INVALID_EMAIL" && errorParsed.response.data != "BLOCKED_USER" && errorParsed.response.data != "USER_NOT_AUTHORIZED" && errorParsed.response.data != "INVALID_PASSWORD")) {
                    dispatch({ type: 'SET_LOGGED', payload: null });
                }
            } else if (errorParsed.status == "408" || errorParsed.status == "504") {
            }

            return Promise.reject(error);
        }
    );

    return children
}

/* Store with context*/
const Store = ({ children }) => {
    const [state, dispatch] = useReducer(Reducer, initialState);
    return (
        <Context.Provider value={[state, dispatch]}>
            <WithAxios>
                {children}
            </WithAxios>
        </Context.Provider>
    )
};
export default Store;